<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh"><span class="epub-b">Contents</span></p>
<p class="cct"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="cct"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="cct"><span href="#/xhtml/epigraph#epi" title="Link target outside of Sample">Epigraphs</span></p>
<p class="cct"><a href="#/xhtml/prologue#pro">Prologue: Out of Print and Scared to Death</a></p>
<p class="cct"><a href="#/xhtml/chapter1#ch1">1: You Were an Accident, 1922–1940</a></p>
<p class="cct"><a href="#/xhtml/chapter2#ch2">2: One of the Biggest Fools on the Hill, 1940–1943</a></p>
<p class="cct"><a href="#/xhtml/chapter3#ch3">3: To War in the Bridal Suite, 1943–1945</a></p>
<p class="cct"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">4: Folk Society and the House of Magic, 1945–1947</span></p>
<p class="cct"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">5: Stop Being Such a Hardheaded Realist, 1948–1951</span></p>
<p class="cct"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">6: The Dead Engineer, 1951–1958</span></p>
<p class="cct"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">7: Cooped Up with All These Kids, 1958–1965</span></p>
<p class="cct"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">8: A Community of Writers, 1965–1967</span></p>
<p class="cct"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">9: The Big Ka-BOOM, 1967–1969</span></p>
<p class="cct"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">10: Goodbye and Goodbye and Goodbye, 1969–1971</span></p>
<p class="cct"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">11: Cultural Bureaucrat, 1971–1974</span></p>
<p class="cct"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">12: Ripped Off, 1975–1979</span></p>
<p class="cct"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">13: Looking for Mr. Vonnegut, 1980–1984</span></p>
<p class="cct"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">14: Dear Celebrity, 1984–1991</span></p>
<p class="cct"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">15: Waiting to Die, 1992–2007</span></p>
<p class="cbmh"><span href="#/xhtml/appendix#app" title="Link target outside of Sample">Appendix: Vonnegut-Lieber Family History</span></p>
<p class="cbmh"><span href="#/xhtml/notes#note" title="Link target outside of Sample">Notes</span></p>
<p class="cbmh"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="cbmh"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cbmh"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
<p class="cbmh"><span href="#/xhtml/author#aut" title="Link target outside of Sample">About the Author</span></p>
<p class="cbmh"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample">Also by Charles J. Shields</span></p>
<p class="cbmh"><span href="#/xhtml/copyright#copy" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7e2b0b04